import format from 'string-format'
import {EventEmitter} from "events"

class ModelBase {

	constructor(data) {

		if (data != null) {
			// копируем все атрибуты объекта, полученного из REST
			for (const key in data)

				if (!(key in this)) {
					this[key] = data[key]
				} else {
					// TODO: что делать с полями data, если в классе есть аттрибут с таким названием?
					// пока положимся, что в конструкторе наследников такие обрабатываются
					// this.process_data(key, data[key])
				}

		} else {
			// передан пустой объект
			console.warning(format("Model '{0}' empty data object", typeof (this)))
			this.empty = true
		}
	}
}

export {ModelBase}